/** The Specification stage: the Detailed Description framework, read and written whole. */

import { get, post, put } from "@/services/api-client";
import type {
  FrameworkResponse,
  ReplaceFrameworkRequest,
} from "@patent-studio/api-types";

const framework = (taskId: string) =>
  `/tasks/${taskId}/specification/framework`;

export function getFramework(taskId: string): Promise<FrameworkResponse> {
  return get<FrameworkResponse>(framework(taskId));
}

/** The whole framework as the attorney left it, under the version it was built on. */
export function replaceFramework(
  taskId: string,
  body: ReplaceFrameworkRequest,
): Promise<FrameworkResponse> {
  return put<FrameworkResponse>(framework(taskId), body);
}

/** The yes, given against the address the page was served, so it cannot land on another framework. */
export function confirmFramework(
  taskId: string,
  address: string,
): Promise<FrameworkResponse> {
  return post<FrameworkResponse>(`${framework(taskId)}/confirm`, { address });
}

/** Asks Praxis for a framework; it lands through the worker, and the stream says when. */
export function proposeFramework(taskId: string): Promise<FrameworkResponse> {
  return post<FrameworkResponse>(`${framework(taskId)}/propose`);
}
